import type { AxiosRequestConfigExtended } from '@vision/ui/interfaces';
import type {
  PlannerTaskCommentCreateArgs,
  PlannerTaskCommentDeleteArgs,
  PlannerTaskCommentsArgs,
} from './task-comments.api.types';
import { createHttpExtraOptions } from '@vision/ui/utils';

export const buildCreateCommentRequest = ({
  accountId,
  plannerId,
  dashboardId,
  taskId,
  content,
  attachments,
}: PlannerTaskCommentCreateArgs): AxiosRequestConfigExtended => {
  const formData = new FormData();
  formData.append('content', content);

  if (attachments?.length) {
    attachments.forEach((file) => formData.append('attachments[]', file));
  }

  return {
    url: `/v2/planners/${plannerId}/comments`,
    method: 'POST',
    params: {
      account_id: accountId,
      dashboard_id: dashboardId,
      task_id: taskId,
    },
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    extraOptions: createHttpExtraOptions({
      notification: {
        translationMessageKey: 'http.message.planner.createComment.{{status}}',
        autoHandleSuccess: false,
      },
    }),
  };
};

export const buildDeleteCommentRequest = ({
  accountId,
  plannerId,
  dashboardId,
  taskId,
  commentId,
}: PlannerTaskCommentDeleteArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/comments/${commentId}/delete`,
  method: 'POST',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.deleteComment.{{status}}',
    },
  }),
});

export const buildGetCommentsRequest = ({
  accountId,
  plannerId,
  dashboardId,
  taskId,
}: PlannerTaskCommentsArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/comments`,
  method: 'GET',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
});
